import EDatepicker from '../datepicker';
import JSLogger from '../../../utils/jslogger';
const log = new JSLogger('decommission');

const parseTime = string => string.match(/\w+\:\w+/);

class EDatetimePicker extends EDatepicker {
  init() {
    super.init();
    this._dom.popper.classList.add('e-datetimepicker');
    this._dom.timepicker = document.createElement('e-timepicker');
    this._dom.timepicker.className = 'e-datetimepicker__time';
    this._dom.calendar.classList.add('e-datetimepicker__date');
    this._dom.timepicker.addEventListener('update', this._updateTime.bind(this));
    this._dom.calendar.addEventListener('now', this._now.bind(this));
    this._dom.input.format = 'ymdhi';
  };

  connectedCallback() {
    super.connectedCallback();
    log.log('EDatetimePicker');
  }

  set value(value) {
    if (this.value === value) {
      return;
    }

    [this._date, this._time] = value ? this._getDateTime(value) : ['', ''];

    const parsedTime = this._time ? parseTime(this._time) : false;
    this._time = parsedTime ? parsedTime[0] : '';

    this._updateValue(value || '');
    this.setAttribute('value', this.value);
    this._dom.calendar.setAttribute('date', this._date);
    this._dom.timepicker.setAttribute('value', this._time);
  }

  _getDateTime(value) {
    return (value.indexOf('T') > -1) ? value.split('T') : value.split(' ');
  }

  get value() {
    return super.value;
  }

  open() {
    this._dom.popper.appendChild(this._dom.timepicker);
    if (!this._time) {
      this._time = '00:00';
    }
    super.open();
  }

  _now() {
    const now = new Date();
    this._dom.timepicker.value = this._pad(now.getHours()) + ':' + this._pad(now.getMinutes());
  }

  _pad(number) {
    const s = '0' + number;
    return s.substr(s.length - 2);
  }

  _updateDate(event) {
    this._date = event.detail.date;

    if (!this._date || !this._time) {
      return;
    }

    this._updateValue(`${this._date} ${this._dom.timepicker.value}`);
  }

  _updateTime(event) {
    this._time = event.detail.time['24h'];

    if (!this._date || !this._time) {
      return;
    }

    this._updateValue(`${this._date} ${this._time}`);
  }

  _updateValue(value) {
    if (this._value === value) { return; }
    this._value = value;
    this._dom.input.datetime = value;
    this._handleClearButton();
    this._dispatchEvent('update');
  }
}

export default EDatetimePicker;
